export default __webpack_public_path__ + "static/media/dog7.93b8ba9f.png";